import { HomeinnsSSO, encryptionHomeinnsSSO } from './Homeinns.SSO.CustomEncryption.Public';
// 请求参数加密
function encryptFn(encrypt, token) {
    const str = JSON.stringify(encrypt);

    let _i = 1; _i++;
    const _TK = token; // token; // .replace(/-/g, "").replace(/_/g, "")
    // token 的长度_KEY_i=2的5冥 32
    // _TK.substring(_TK.length - Math.pow(_i, 5));
    const _KEY = token;
    // const _IV = _TK.substring(0, parseInt(_KEY.length / _i));
    // 偏移量  取前 16位
    const _IV = _TK.substring(0, parseInt(_KEY.length / _i));
    const key = encryptionHomeinnsSSO.enc.Utf8.parse(_KEY);
    const iv = encryptionHomeinnsSSO.enc.Utf8.parse(_IV);
    const srcs = encryptionHomeinnsSSO.enc.Utf8.parse(str);
    const encrypted = HomeinnsSSO.AES.encrypt(srcs, key, {
        iv: iv,
        mode: HomeinnsSSO.mode.CBC,
        padding: HomeinnsSSO.pad.Pkcs7
    });
    return encrypted.ciphertext.toString();
}

export default function paramsMerge(params) {
    const elToken = document.getElementsByName("__RequestVerificationToken")[0].value;
    const sessionToken = sessionStorage.getItem("hidRequestVerificationToken") || elToken;
    const token = !window.sessionStorage ? "" : sessionToken;
    const DataMorge = encryptFn(params, token)
    params = {
        Data: DataMorge
    }
    return params;
}
